<template>
  <v-app>
    <v-container style="background-color:#18A889; padding: 10px 10px 40px 10px; margin-bottom: 20px;">
      <h1 class="display-2 text-xs-center">
        HEALTH & SAFETY
      </h1>
      <h5 class="headline text-xs-center">
        WORKPLACE ASSESSMENT
      </h5>
      <v-card>
        <v-card-title>
          <v-flex xs6>
            <h4>Company:</h4> {{ company.name }}
          </v-flex>
          <v-flex xs6>
            <h4>Date:</h4> {{ currentDate() }}
          </v-flex>
        </v-card-title>
      </v-card>
      <v-container mt-2>
        <v-card dark>
          <v-card-text>
            <v-form ref="userInfo">
              <v-text-field label="Name" v-model="name" :rules="rules" required></v-text-field>
                <v-text-field label="Contact Number" v-model="contact" :rules="rules" required></v-text-field>
              <v-select label="Department" :items="department" :rules="rules" v-model="departmentChosen" required></v-select>
              <v-text-field label="Id" v-model="id" :rules="rules" required></v-text-field>
              <v-text-field label="Email" v-model="email" :rules="rules" required></v-text-field>
              <v-select label="Gender" :items="gender" :rules="rules" v-model="genderChosen" required></v-select>
            </v-form>
          </v-card-text>
        </v-card>
      </v-container>
    </v-container>
  </v-app>
</template>
<script>
import moment from 'moment';
import db from '@/components/firebase.init';
export default {
  props:['company'],
  data() {
    return {
      name: '',
      department: [
        'Finance', 'HumanResource', 'InformationTechnology', 'Operation',
        'ResearchandDevelopment', 'SalesandMarketing', 'Production','Logistic', 'CustomerSupport', 
        'ProcurementandPurchasing',
        'Engineering',
        'GroundCrew',
        'Aviation',
        'TechnicalSupport',
        'CabinCrew',
        'Others'],
      id: '',
      date: '',
      email: '',
      contact:'',
      rules: [(v) => !!v || 'Please in this field'],
      showDate: false,
      genderChosen: '',
      departmentChosen: '',
      gender: ['Male', 'Female'],
      window:{
          width: 0,
          height: 0
      }
    };
  },
  methods: {
    currentDate(){
      return moment().format('Do MMMM YYYY')
    },
    responsiveStyle() {
      return this.window.width >= 480 ? "width: 48%" : "";
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    validate(){
      return this.$refs.userInfo.validate()
    },
    submit(){
      let affectedParts = this.$store.state.affectedParts;
      var parts = {
        neck: 0,
        knee: 0,
        general: 0,
        elbow: 0,
        back: 0,
        wrist: 0
      }
      

      for(var x = 0; x < affectedParts.length; x++){
        if(affectedParts[x] == 'Neck'){
          parts.neck++;
        }
        else if(affectedParts[x] == 'Knee'){
          parts.knee++;
        }
        else if(affectedParts[x] == 'General'){
          parts.general++;
        }
        else if(affectedParts[x] == 'Elbow'){
          parts.elbow++;
        }
        else if(affectedParts[x] == 'Back'){
          parts.back++;
        }
        else if(affectedParts[x] == 'Wrist'){
          parts.wrist++;
        }
      }
         var status = '';
                if(this.company.assessment=='NO'){
                    status = 'GENERATING REPORT';
                }
          

      return db.collection('forms').add(
        {
            name: this.name,
            department: this.departmentChosen,
            contact:this.contact,
            company_id: this.company.id,
            id: this.id,
            email: this.email,
            gender: this.genderChosen,
            date: this.currentDate(),
            neck_total: parts.neck,
            knee_total: parts.knee,
            general_total: parts.general,
            elbow_total: parts.elbow,
            back_total: parts.back,
            wrist_total: parts.wrist,
            status:status
        }
      )
    }
  },
  filters: {
    capitalize(value) {
      if (!value) {
        return "";
      }
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    
              
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>
<style scoped>

h5{
  margin-bottom: 50px;
}
</style>




